export function objectValues(object: object): any[] {
	return Object.values(object);
}
